import React from "react";
import "./CardComponent.css";


export default function CardComponent({
  title,
  header,
  children,
  headerColor = "#0f7a1f",
  borderColor = "#0f7a1f",
  borderWidth = 2,
  className = "",
  style,
  bodyStyle,
  headerStyle,
}) {
  const showHeader = header != null || (title != null && title !== "");

  return (
    <section
      className={`mfl-card ${className}`.trim()}
      style={{
        border: `${borderWidth}px solid ${borderColor}`,
        ...style,
      }}
    >
      {showHeader && (
        <header
          className="mfl-card__header"
          style={{ background: headerColor, ...headerStyle }}
        >
          {header != null ? <>{header}</> : <span className="mfl-card__title">{title}</span>}
        </header>
      )}
      <div className="mfl-card__body" style={bodyStyle}>
        {children}
      </div>
    </section>
  );
}

